'use client'

import { usePathname } from 'next/navigation'
import { motion, AnimatePresence } from 'framer-motion'
import { Join } from '../../lib/utils'

interface AnimatedArticleProps {
  children: React.ReactNode
  /** Merged with default prose + layout classes (same shell as product MDX docs). */
  className?: string
}

export function AnimatedArticle({ children, className }: AnimatedArticleProps) {
  const pathname = usePathname()

  return (
    <AnimatePresence mode="wait">
      {children && (
        <motion.article
          key={pathname}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.5 } }}
          exit={{ opacity: 0, transition: { duration: 0.0 } }}
          className={Join(
            'prose prose-slate dark:prose-invert mx-auto min-h-[50vh] w-full max-w-prose',
            className,
          )}
        >
          {children}
        </motion.article>
      )}
    </AnimatePresence>
  )
}
